// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input_search {
  margin-bottom: 8px;
}

.drawer_listing_empty {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/AppointmentsComponents/AppointmentsDrawerExistEntity/AppointmentsDrayewExistEntity.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AACA;EACI,gBAAA;AAEJ","sourcesContent":[".input_search {\r\n    margin-bottom: 8px;\r\n}\r\n.drawer_listing_empty {\r\n    margin-top: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
